<a
  [routerLink]="routerLink"
  [title]="'Edit' | translate"
  class="success ml-1 mr-1 font-medium-2"
  [queryParams]="params"
><i class="ft-edit-2"></i></a>
